import BudgetVisual1 from "../../img/screenshots/budgetplanner/budget-01.png";
import BudgetVisual2 from "../../img/screenshots/budgetplanner/budget-02.png";
import BudgetVisual3 from "../../img/screenshots/budgetplanner/budget-03.png";
import BudgetVisual4 from "../../img/screenshots/budgetplanner/budget-05.png";

export const BudgetTrackerFeaturesContent = [
  {
    title: "Manage expenses effortlessly and on the go ",
    subtitle: "Add & Categorise expenses on-the-go",
    text: "Keep your travel budget in check with real-time tracking, so you can focus on the adventure without worrying about overspending. Effortless, organised, and always within reach.",
    image: BudgetVisual1,
  },
  {
    title: "Visualize your travel spending with ease",
    subtitle: "Get immediate graphic insights",
    text: "Take the guesswork out of your travel budget! With graphic insights, you can get a clear view of where your money is going—whether it's daily expenses or category breakdowns. Instantly spot trends, adjust your spending, and make smarter financial decisions on the go.",
    image: BudgetVisual2,
  },
  {
    title: "Settle expenses among co-travelers with ease",
    subtitle: "Settle expenses",
    text: "Traveling with friends? Track shared expenses and settle up while you are on the move. Whether it's food, accommodations, or group activities, the expenses tracker ensures everyone pays their fair share—no need for awkward conversations or complicated math.",
    image: BudgetVisual3,
  },
  {
    title: "Convert currencies on the go when changing countries",
    subtitle: "convert currencies",
    text: "Crossing borders shouldn’t mean confusion with your budget! Instantly convert currencies as you travel from country to country, ensuring you always know exactly what you're spending. ",
    image: BudgetVisual4,
  },
];
